import apiRequest from '../../lib/http'
import { businessTimeZone } from '../../utils/date'

export const downloadPaymentCsv = async ({ startDate, endDate, type }) => {
  const response = await apiRequest.post('/exports/payment-lists', {
    startDate,
    endDate,
    type,
    timezone: businessTimeZone
  }, {
    responseType: 'blob'
  })

  const contentDisposition = response.headers['content-disposition']
  let filename = `bankcow_${type}_payments_${startDate}_to_${endDate}.csv`
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";\n]+)"?/)
    if (match) filename = match[1]
  }

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)

  return { filename }
}
